/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ismandatory1Inputs */

const en_entity_ismandatory1 = /** @type {(inputs: Entity_Ismandatory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Mandatory`)
};

const de_entity_ismandatory1 = /** @type {(inputs: Entity_Ismandatory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Pflichtfeld`)
};

/**
* | output |
* | --- |
* | "Is Mandatory" |
*
* @param {Entity_Ismandatory1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ismandatory1 = /** @type {((inputs?: Entity_Ismandatory1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ismandatory1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ismandatory1(inputs)
	return de_entity_ismandatory1(inputs)
});
export { entity_ismandatory1 as "entity_isMandatory" }